/* Casarão Lustres — interações do layout (carrossel, busca, menu mobile, copiar endereço) */
(function () {
  'use strict';

  function initSlider(root) {
    if (root.dataset.clReady) return;
    root.dataset.clReady = '1';
    var track = root.querySelector('[data-cl-track]');
    var slides = track ? track.children : [];
    var dots = root.querySelectorAll('[data-cl-dot]');
    var total = slides.length;
    if (total < 2) return;

    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;

    function go(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    root.querySelector('[data-cl-prev]').addEventListener('click', function () { go(index - 1); start(); });
    root.querySelector('[data-cl-next]').addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.clDot, 10)); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1));
      startX = null;
      start();
    });

    start();
  }

  function initSearch(form) {
    if (form.dataset.clReady) return;
    form.dataset.clReady = '1';
    var input = form.querySelector('input[name="q"]');
    form.querySelector('[data-cl-search-toggle]').addEventListener('click', function (e) {
      if (!form.classList.contains('is-open')) {
        e.preventDefault();
        form.classList.add('is-open');
        input.focus();
      } else if (!input.value.trim()) {
        e.preventDefault();
        form.classList.remove('is-open');
      }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !input.value.trim()) form.classList.remove('is-open');
    });
  }

  function initMenu(header) {
    if (header.dataset.clReady) return;
    header.dataset.clReady = '1';
    var menu = header.querySelector('.cl-mobile-menu');
    var overlay = header.querySelector('.cl-overlay');
    var opener = header.querySelector('[data-cl-menu-open]');
    if (!menu || !opener) return;

    function open() {
      menu.classList.add('is-open');
      overlay.classList.add('is-visible');
      menu.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      menu.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    opener.addEventListener('click', open);
    header.querySelectorAll('[data-cl-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    header.querySelectorAll('[data-cl-sub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (sub) sub.classList.toggle('is-open', !expanded);
      });
    });
  }

  function initCopy(btn) {
    if (btn.dataset.clReady) return;
    btn.dataset.clReady = '1';
    btn.addEventListener('click', function () {
      var text = btn.dataset.clCopy;
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        btn.classList.add('is-copied');
        btn.setAttribute('title', 'Endereço copiado');
        setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.setAttribute('title', 'Copiar endereço');
        }, 2000);
      });
    });
  }

  function initFilters(form) {
    if (form.dataset.clReady) return;
    form.dataset.clReady = '1';
    var submit = function () {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.href = form.action + (params.toString() ? '?' + params.toString() : '');
    };
    form.querySelectorAll('input[type="checkbox"]').forEach(function (el) { el.addEventListener('change', submit); });

    form.querySelectorAll('[data-cl-price]').forEach(function (box) {
      var max = parseFloat(box.dataset.max) || 0;
      var lo = box.querySelector('[data-cl-price-min]');
      var hi = box.querySelector('[data-cl-price-max]');
      var fill = box.querySelector('[data-cl-price-fill]');
      var label = box.querySelector('[data-cl-price-label]');
      var loField = box.querySelector('[data-cl-price-min-field]');
      var hiField = box.querySelector('[data-cl-price-max-field]');
      var fmt = function (n) { return 'R$ ' + Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2 }); };
      function paint() {
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
        if (max > 0) {
          fill.style.left = (a / max * 100) + '%';
          fill.style.right = (100 - b / max * 100) + '%';
        }
        label.textContent = fmt(a) + ' – ' + fmt(b);
      }
      function commit() {
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
        loField.value = a > 0 ? a : '';
        hiField.value = b < max ? b : '';
        submit();
      }
      [lo, hi].forEach(function (el) {
        el.addEventListener('input', paint);
        el.addEventListener('change', commit);
      });
      paint();
    });
  }

  function initFiltersToggle(btn) {
    if (btn.dataset.clReady) return;
    btn.dataset.clReady = '1';
    btn.addEventListener('click', function () {
      var box = btn.closest('.cl-filters');
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  function initSort(select) {
    if (select.dataset.clReady) return;
    select.dataset.clReady = '1';
    select.addEventListener('change', function () { select.form.submit(); });
  }

  function initMore(link) {
    if (link.dataset.clReady) return;
    link.dataset.clReady = '1';
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var grid = document.querySelector('[data-cl-grid]');
      if (!grid || link.classList.contains('is-loading')) return;
      link.classList.add('is-loading');
      link.textContent = 'Carregando...';
      fetch(link.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-cl-grid]');
        if (nextGrid) Array.from(nextGrid.children).forEach(function (card) { grid.appendChild(card); });
        var nextLink = doc.querySelector('[data-cl-more]');
        if (nextLink) {
          link.href = nextLink.href;
          link.textContent = nextLink.textContent;
          link.classList.remove('is-loading');
        } else {
          link.parentNode.remove();
        }
      }).catch(function () { window.location.href = link.href; });
    });
  }

  function init() {
    document.querySelectorAll('[data-cl-slider]').forEach(initSlider);
    document.querySelectorAll('[data-cl-search]').forEach(initSearch);
    document.querySelectorAll('[data-cl-header]').forEach(initMenu);
    document.querySelectorAll('[data-cl-copy]').forEach(initCopy);
    document.querySelectorAll('[data-cl-filters]').forEach(initFilters);
    document.querySelectorAll('[data-cl-filters-toggle]').forEach(initFiltersToggle);
    document.querySelectorAll('[data-cl-sort]').forEach(initSort);
    document.querySelectorAll('[data-cl-more]').forEach(initMore);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
